<template>
  <div class="home-div">
    <SideBar />
    <div class="map-container">
      <div class="map-left">
        <!-- 运行时间卡片 -->
        <div class="left-item-div">
          <div class="left-item-header font-color-1">
            <div class="time-div">
              <img class="left-icon" src="@/assets/icon/icon-9.png" />
              <div class="gradient-text" style="font-size: 24px">
                我们已在世界流浪许久
              </div>
              <img class="left-icon" src="@/assets/icon/icon-10.png" />
            </div>
            <div v-html="timeDiffDisplay" class="gradient-text-no"></div>

            <div class="green-dash-divider"></div>

            <!-- ========== 新增本站信息，放在时间下方、左对齐 ========== -->
            <div class="site-info-card">
              <div class="site-info-content">
                <div class="info-line">名称: 了栀林</div>
                <div class="info-line">描述: 风带来故事的种子～</div>
                <div class="info-line">网址: <a href="https://liaozhi.site" target="_blank">https://liaozhi.site</a></div>
                <div class="info-line">头像: <a href="https://liaozhi.site/file/gingercat/default/home.jpg" target="_blank">https://liaozhi.site/file/gingercat/default/home.jpg</a></div>
                <div class="info-line">提示: 留下友链后会尽快审核，还请将本网站也添加为您的友链哦！</div>
              </div>
            </div>
          </div>
        </div>

        <!-- 绿色虚线分隔线（不影响任何布局） -->
        <div class="green-dash-divider"></div>

        <div class="friend-list-wrapper">
          <!-- 添加友链卡片（放在最前面） -->
          <div class="friend-card" @click="openCreateFriendLink">
            <div class="add-icon">✉️</div>
            <div style="margin-left: 14px;" class="friend-info">
              <div class="friend-name">有朋自远方来</div>
              <div class="friend-desc">点击留下您的世界小屋~</div>
            </div>
          </div>
          
          <!-- 原有友链循环 -->
          <div
            class="friend-card"
            v-for="item in friendList"
            :key="item.id"
            @click="toFriendLink(item.link)"
          >
            <img
              class="friend-avatar"
              :src="item.img"
              :alt="item.title"
              @error="handleImageError($event, item.title)"
            />
            <div class="friend-info">
              <div class="friend-name">{{ item.title }}</div>
              <div class="friend-desc">{{ item.desc }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <BottomTip />

    <!-- 友链弹窗组件 -->
    <CreateFriendLink :isVisible="showFriendLink" @close="handleShow($event)"
        @update:visible="showFriendLink = $event" :friendLink="friendLink" />
  </div>
</template>

<script>
import SideBar from "@/components/menu/SideBar.vue";
import BottomTip from "@/components/menu/BottomTip.vue";
import CreateFriendLink from "@/components/CreateFriendLink.vue";
import { getAnalysisData } from "@/api/analysis.js";
import { getFriendList } from "@/api/friendLink";

export default {
  name: "Analysis",
  components: {
    SideBar,
    BottomTip,
    CreateFriendLink,
  },
  data() {
    return {
      friendList: [],
      targetDate: null,
      timeDiffDisplay: "等待设置目标日期...",
      timer: null,
      showFriendLink: false,
      friendLink: {
        id: null,
        title: '',
        desc: '',
        link: '',
        img: '',
        status: "0"
      },
    };
  },
  async mounted() {
    await this.getFriendListInfo();
    await this.getAnalysisData();
    this.startTimer();
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
  },
  watch: {
    targetDate(newVal) {
      if (newVal) this.startTimer();
    },
  },
  methods: {
    openCreateFriendLink() {
      this.friendLink = {
        id: null,
        title: '',
        desc: '',
        link: '',
        img: '',
        status: "1"
      };
      this.showFriendLink = true;
    },
    onFriendLinkSaved() {
      this.getFriendListInfo();
    },
    handleImageError(event, title) {
      const firstChar = title ? this.getFirstChar(title) : "?";
      const placeholder = document.createElement("div");
      placeholder.className = "text-placeholder";
      placeholder.textContent = firstChar;
      placeholder.style.cssText = `
        width: 100%; height: 100%; display: flex; align-items: center; justify-content: center;
        background: linear-gradient(135deg, #3498db, #8e44ad); color: white; font-size: 24px; font-weight: bold; border-radius: 50%;
      `;
      event.target.parentNode.replaceChild(placeholder, event.target);
    },
    getFirstChar(text) {
      if (!text) return "?";
      const c = text.charAt(0);
      if (/[\u4e00-\u9fa5]/.test(c)) return c;
      if (/[a-zA-Z]/.test(c)) return c.toUpperCase();
      return "?";
    },
        async handleShow(event) {
      switch (event) {
        case TypeEnum.CREATE_FRIEND_LINK: this.showFriendLink = !this.showFriendLink; break; 
      }
    },
    calculateTimeDiff() {
      if (!this.targetDate) {
        this.timeDiffDisplay = "等待设置目标日期...";
        return;
      }
      const now = new Date();
      const target = new Date(this.targetDate);
      if (target > now) { this.timeDiffDisplay = "目标日期在未来"; return; }

      let years = now.getFullYear() - target.getFullYear();
      let months = now.getMonth() - target.getMonth();
      let days = now.getDate() - target.getDate();
      let hours = now.getHours() - target.getHours();
      let minutes = now.getMinutes() - target.getMinutes();
      let seconds = now.getSeconds() - target.getSeconds();

      if (seconds < 0) { seconds += 60; minutes--; }
      if (minutes < 0) { minutes += 60; hours--; }
      if (hours < 0) { hours += 24; days--; }
      if (days < 0) {
        const lastMonth = new Date(now.getFullYear(), now.getMonth(), 0);
        days += lastMonth.getDate(); months--;
      }
      if (months < 0) { months += 12; years--; }

      const parts = ['第'];
      if (years>0) parts.push(`<span class="num">${years}</span>年`);
      if (months>0) parts.push(`<span class="num">${months}</span>月`);
      if (days>0) parts.push(`<span class="num">${days}</span>天`);
      if (hours>0) parts.push(`<span class="num">${hours}</span>时`);
      if (minutes>0) parts.push(`<span class="num">${minutes}</span>分`);
      if (seconds>0) parts.push(`<span class="num">${seconds}</span>秒`);
      this.timeDiffDisplay = parts.join('') || '<span class="num">0</span>秒';
    },
    startTimer() {
      clearInterval(this.timer);
      this.calculateTimeDiff();
      this.timer = setInterval(() => this.calculateTimeDiff(), 1000);
    },
    toFriendLink(link) {
      window.open(link, "_blank");
    },
    async getFriendListInfo() {
      try {
        const resp = await getFriendList();
        if (resp.code === 200) {
          this.friendList = resp.data;
        } else {
          this.$message.error(resp.msg || "加载失败");
        }
      } catch (error) {
        this.$message.error("网络错误");
      }
    },
    async getAnalysisData() {
      try {
        const resp = await getAnalysisData({});
        if (resp.code === 200) {
          this.targetDate = resp.data.createdTime;
        }
      } catch (e) {}
    },
  },
};
</script>

<style scoped>
/* 全局保留你的布局 + 不覆盖背景 */
.home-div {
  width: 100%;
  min-height: calc(100vh - 60px);
  padding-top: 60px;
  background: transparent !important;
  overflow: hidden;
}

.map-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

.map-left {
  width: 100%;
  min-height: calc(100vh - 150px);
}

/* ==================== 绿色优美虚线（完全不影响原有布局） ==================== */
.green-dash-divider {
  width: 90%;
  height: 1px;
  margin: 0 auto 25px;
  background: linear-gradient(to right, transparent, rgba(72, 187, 120, 0.6), transparent);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
  border: none;
  opacity: 0.8;
}

/* ========== 本站信息卡片，左对齐 ========== */
.site-info-card {
  margin-top: 12px;
  text-align: left;
}
.info-line {
  font-size: 16px;
  color: var(--font-color-4);
  line-height: 2;
}
.info-line a {
  color: #c02674;
  text-decoration: none;
  overflow-wrap: break-word;
  word-break: break-all;
}
.info-line a:hover {
  text-decoration: underline;
}

/* 时间卡片样式 */
.time-div {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
}
.left-icon {
  height: 24px;
}
.gradient-text {
  font-size: 24px;
  font-weight: bold;
  background: linear-gradient(90deg, #ff0080, #ff8c00, #40e0d0, #9370db, #ff0080);
  background-size: 400% 100%;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: gradientMove 8s ease-in-out infinite;
}
.gradient-text-no {
  font-size: 16px;
  font-weight: bold;
  color: var(--font-color-4) !important;
  margin-bottom: 20px;
}
.num {
  font-size: 32px;
  font-weight: bold;
  color: #fff !important;
}
@keyframes gradientMove {
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
}

.left-item-div {
  margin-bottom: 30px;
  text-align: center;
  border-radius: 10px;
  background-color: rgba(255, 250, 240, 0.7);
  backdrop-filter: blur(16px) saturate(180%);
  -webkit-backdrop-filter: blur(16px) saturate(180%);
  border: 1px solid rgba(200, 180, 140, 0.5);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.5s cubic-bezier(0.22, 0.61, 0.36, 1);
}
.left-item-header {
  padding: 20px;
}

/* ------------------------------ */
/* 以下是 poetize.cn 同款友链样式 */
/* ------------------------------ */
.friend-list-wrapper {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
  width: 100%;
}

.friend-card {
  display: flex;
  align-items: center;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  padding: 14px 18px;
  cursor: pointer;
  transition: all 0.3s ease;
  background-color: rgba(255, 250, 240, 0.7);
  backdrop-filter: blur(16px) saturate(180%);
  -webkit-backdrop-filter: blur(16px) saturate(180%);
  border: 1px solid rgba(200, 180, 140, 0.5);
  box-shadow:
    7px 7px 10px rgba(0, 0, 0, .9),
    -5px -5px 10px rgba(239, 235, 235, 0.3);
  transition: all 0.5s cubic-bezier(0.22, 0.61, 0.36, 1);
}

.friend-card:hover {
  transform: translateY(-6px);
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.2);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
}

.friend-avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  object-fit: cover;
  margin-right: 14px;
  flex-shrink: 0;
  border: 2px solid rgba(255, 255, 255, 0.2);
}

.friend-info {
  flex: 1;
  overflow: hidden;
}

.friend-name {
  font-size: 16px;
  font-weight: 500;
  color: var(--font-color-1) !important;
  margin-bottom: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.friend-desc {
  font-size: 13px;
  color: var(--font-color-4) !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 添加友链卡片样式 */
.add-friend-card {
  justify-content: center;
  border-style: dashed !important;
  border-color: rgba(200, 180, 140, 0.6) !important;
  background-color: rgba(255, 255, 255, 0.4) !important;
}

.add-friend-card .friend-info {
  flex: none;
  margin-left: 10px;
}

.add-icon {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  font-weight: bold;
  color: rgba(150, 130, 100, 0.8);
  background: rgba(255, 255, 255, 0.5);
  border: 2px dashed rgba(169, 90, 132, 0.6);
  flex-shrink: 0;
}

.add-friend-card:hover {
  transform: translateY(-6px);
  border-color: rgba(150, 200, 160, 0.8) !important;
}

/* 响应式 */
@media (max-width: 768px) {
  .friend-list-wrapper {
    grid-template-columns: 1fr !important;
  }
  .map-container {
    padding: 15px !important;
  }
}
</style>
